













































import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import Service from '@/modules/reservation/model/Service'
import {Action, State} from 'vuex-class'
import ServiceDetail from '@/modules/reservation/components/ServiceDetail.vue'
import Loader from '@/components/Loader.vue';
import ConfirmDeleteReservationService from '@/modules/reservation/components/ConfirmDeleteReservationService.vue';

/**
 * Lista de servicios de reserva
 *
 * Muestra al usuario la lista de servicios para departamentos registrados
 * en la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ConfirmDeleteReservationService, Loader, ServiceDetail},
})
export default class ServicesList extends Vue {
    /**
     * Lista de servicios
     */
    @State(state => state.reservation.services)
    public services: Service[]

    @Action('reservation/loadServicesList')
    public loadServices: (payload?: {force?: boolean}) => void

    @Action('reservation/editService')
    public edit: (service: Service) => void

    public loading = true
    public reloading = false

    public confirmDeleteService = false
    public serviceToDelete = new Service()

    public headers = [
        { text: 'Id', value: 'id'},
        { text: 'Nombre', value: 'name'},
        { text: 'Precio', value: 'price'},
        { text: 'Fecha de creación', value: 'createdAt'},
        { text: 'Fecha de actualización', value: 'updatedAt'},
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center'},
    ]

    /**
     * Formatea una fecha para mostrarla al usuario
     *
     * @param date
     */
    public fancyDate (date: Date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }

    /**
     * Al crear el componente carga la lista de servicios
     */
    public async created () {
        await this.loadServices()
        this.loading = false
    }

    /**
     * Recarga la lista de servicios
     */
    public async reload () {
        this.reloading = true
        await this.loadServices({force: true})

        this.reloading = false
    }

    /**
     * Activa el componente de edición para crear un nuevo servicio
     */
    public addService () {
        this.edit(new Service())
    }
}
